import { calcDateSpanDescription, FullBlock } from 'model';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import styles from './BlockListUser.module.css';
import { BlockUser } from './BlockUser';
import { ProfilePic } from './ProfilePic';
interface blockListUserType {
	block: FullBlock;
}
export const BlockListUser: React.FC<blockListUserType> = ({ block }) => {
	const { userToBlock: user } = block;

	return (
		<div className={styles.blockedUserContainer}>
			<div className={styles.blockedUser}>
				<ProfilePic user={user} />
				<div className="fullwidth">
					<div className={sharedStyles.name}>{user.username}</div>
					<div className={sharedStyles.time}>Hidden {calcDateSpanDescription(block.created)}</div>
				</div>
			</div>
			<div>
				<BlockUser userToBlock={block.userToBlock} />
			</div>
		</div>
	);
};
